import img from "../Images/Book_Demo.png"

const saralTransportFeatures = {
    featureTitle :"Features of",
    title_s:"Saral Transport",
    featureDescription:"Manage bilties, track receipts, and upload PODs instantly for seamless logistics. Enable real-time shipment tracking and automated billing to enhance efficiency.",
    featureLists : [
        {
          title: "Bilty to Money Receipt Management",
          description: "Effortlessly Create and manage bilties, track receipts, and maintain clear transaction records."
        },
        {
          title: "Mobile Application for Instant POD Upload",
          description: "Scan POD via Mobile app for instant attachment, real-time confirmation, and enhanced transparency."
        },
        {
          title: "Real-Time Tracking via Client Portal",
          description: "Consignees track shipments in real-time for better planning and logistics management."
        },
        {
          title: "Automated Billing for Pending Amounts",
          description: "The client portal enables consignees to generate bills, streamlining payments and reducing disputes."
        },
       
      ]
}

const whyChooseTransport = {
  title: "Why Choose",
  title_h: "Saral Transport?",
  description:
    "For transporters, managing bilties, payments, and vehicle tracking can be overwhelming. Saral Transport is designed to simplify your entire transportation workflow. Here’s why it’s the best choice:",
    lists: [
      {
        title: "End-to-End Transport Management",
        description: "Manage bilty, receipts, and transport operations in one place."
      },
      {
        title: "Mobile App for On-the-Go Updates",
        description: "Upload PODs and manage consignments from your mobile."
      },
      {
        title: "E-Way Bill Tracking Integration",
        description: "Track expiring and in-transit e-way bills for compliance."
      },
      {
        title: "Client Portal for Transparency",
        description: "Clients can track shipments, payments, and reports."
      },
      {
        title: "Smart Financial & Operational Insights",
        description: "Get reports on payments, vehicle use, and performance."
      },
      {
        title: "Scalable & Cost-Effective",
        description: "Flexible pricing for small transporters and large fleets."
      },
      {
        title: "Trusted by 100+ Transporters",
        description: "Join businesses improving efficiency with Saral Transport."
      }
    ]
    ,
  img: img
};

  
export {saralTransportFeatures,whyChooseTransport}  